/* eslint-disable @typescript-eslint/ban-types */
import { RadioGroup, RadioProps } from '@mui/material';
import { Control, Controller, Path, RegisterOptions } from 'react-hook-form';

import LabelRadio, { LabelRadioProps } from '../LabelRadio/LabelRadio';

export interface Radio {
  value: string | boolean;
  label: string;
}

interface FormRadioProps<T> {
  name: Path<T>;
  control: Control<T, object>;
  rules?: RegisterOptions;
  row?: boolean;
  radios: Radio[];
  LabelRadioProps?: LabelRadioProps;
  RadioProps?: RadioProps;
}

export const FormRadio = <T,>({
  name,
  control,
  rules,
  row = true,
  radios,
  LabelRadioProps,
  RadioProps,
}: FormRadioProps<T>): JSX.Element => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <RadioGroup
        row={row}
        aria-label={name}
        name={name}
        value={field.value}
        onChange={field.onChange}
      >
        {radios?.map((r, i) => (
          <LabelRadio
            key={i}
            {...LabelRadioProps}
            value={r.value}
            label={r.label}
            RadioProps={RadioProps}
          />
        ))}
      </RadioGroup>
    )}
  />
);
